import { useState, useEffect } from "react";

/**
 * useBreakpoint is a custom hook that listens for changes in the window's media query status.
 * @param {string} mediaQuery - The media query to listen for.
 * @returns {boolean} The current status of the media query (true if the document matches the media query, false otherwise).
 */
const useBreakpoint = (mediaQuery) => {
    const [status, setStatus] = useState();

    useEffect(() => {
        // Create a MediaQueryList object
        const mql = window.matchMedia(mediaQuery);

        // Set the initial status
        setStatus(mql.matches);
        // Update the status whenever the media query status changes
        mql.onchange = (e) => setStatus(e.matches);

        // Cleanup function to remove the event listener when the component unmounts
        return () => {
            mql.onchange = null;
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);

    return status;
};

export default useBreakpoint;
